// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__117G9","inner":"Footer_inner__8puEm"};